import { memo } from "react";
import { Dropdown } from "primereact/dropdown";

const TopbarWarehouseSelector = memo(({ warehouseOptions, selectedAlmacen, onSelect, disabled = false }) => {
  if (!warehouseOptions.length) return null;

  return (
    <div className="landing-warehouse-wrapper">
      <span className="landing-warehouse-label">Selecciona tu comuna</span>
      <Dropdown
        value={selectedAlmacen}
        options={warehouseOptions}
        onChange={(event) => onSelect(event.value)}
        disabled={disabled}
        className="landing-search-wrapper-warehouse surface-card border-1 surface-border shadow-1"
        panelClassName="w-full sm:w-14rem"
        valueTemplate={(option) => option ? (
          <div>
            <i className="pi pi-map-marker mr-2"></i>
            {option.label}
          </div>
        ) : "Seleccionar"}
      />
    </div>
  );
});

export default TopbarWarehouseSelector;
